import { Homepage } from 'src/libs/page-home'

export default Homepage
